import React, { Fragment } from "react";
import {
  FormControlLabel,
  FormGroup,
  Checkbox,
  Typography,
  Button,
} from "@material-ui/core";
import VisibilityIcon from "@material-ui/icons/Visibility";

function ViewResult() {
  return (
    <Fragment>
      <Typography  align="center">
        약관 내용 모두 동의
      </Typography>
      <hr />
    </Fragment>
  );
}
function JeonMoonAll(props) {
  const classes = props.useStyles();
  const handleChangeAllYn = (e) => {
    props.onChangeJeonMoonAllYn(e.target.checked);
  };
  const [showResults, setShowResults] = React.useState(false);
  const onView = (e) => {
    e.preventDefault();
    setShowResults(!showResults);
  };
  return (
    <>
      <FormGroup row>
        <FormControlLabel
          control={
            <Checkbox
            disabled={props.SelfCertification}
              checked={props.totalAllYn}
              onChange={handleChangeAllYn}
              name="allYn"
            />
          }
          label={
            <Typography className={classes.TypographyFont}>
              실명인증 전체 동의
            </Typography>
          }
        />
        <Button
          className={classes.Button}
          variant="text"
          color="primary"
          type="submit"
          onClick={onView}
          startIcon={<VisibilityIcon />}
        >
          내용보기
        </Button>
      </FormGroup>

      <hr />
      {showResults ? <ViewResult /> : null}
    </>
  );
}

export default JeonMoonAll;
